<template>
  <div class="lp-modal-wrapper" style="font-size:12px">
    <div class="columns is-multiline">
      <div class="column is-6">
        <div class="flex space-between" style="margin-bottom: 24px">
          <div class="flex align-center">
            <span>검색결과</span>
            <span> {{ filteredCount }}</span>
            <span>개 <span style="color:#ccc"> / </span> 전체</span>
            <span> {{ allCount }}</span>
            <span>개</span>
          </div>
          <!-- 10개씩보기 -->
          <div class="control">
            <span class="select">
              <select v-model="filtered.page_length" @change="selPageLength">
                <option v-for="(it,idx) in pageLengthList"
                        :key="'page-'+idx"
                        :value="it.value">{{ it.label }}</option>
              </select>
            </span>
          </div>
        </div>
        <!-- 테아블 -->
        <div class="columns is-multiline">
          <div class="column is-full" style="height: 500px; overflow-y: scroll;">
            <table class="table">
              <thead>
              <tr>
                <td>번호</td>
                <td>이미지</td>
                <td>상품명</td>
                <td>판매가</td>
                <td>품절여부</td>
                <td>선택</td>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(prod,idx) in tableItems" :key="'prod-'+idx">
                <td>{{ prod.id }}</td>
                <td><div style="text-align: center; display: inline-block;"
                         :style="imgField(prod.img)"></div></td>
                <td>{{ prod.name }}</td>
                <td>{{ prod.price.price | currency }}</td>
                <td>
                  <span v-if="prod.soldout">품절</span>
                  <span v-else>판매</span></td>
                <td><button class="button small" @click="clickProduct(prod)">선택</button></td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!-- 페이지 -->
        <div class="pagination-group">
          <div class="pagination-btn-prev" @click="prevPage">
            <i class="material-icons unselect" style="margin-top:5px">keyboard_arrow_left</i>
          </div>
          <div class="pagination-num"
               v-if="visiblePageNumber(n)"
               v-for="(n,idx) in filtered.total_page"
               :key="'page'+idx">
          <span
            class="unselect"
            :class="{ 'pagination-num-selected' : n===filtered.page_num, 'pagination-num-not-selected' : n!==filtered.page_num }"
            @click="changePage(n)" style="font-size:1.2rem">{{ n }}</span>
          </div>
          <div class="pagination-btn-next" @click="nextPage">
            <i class="material-icons unselect" style="margin-top:5px">keyboard_arrow_right</i>
          </div>
        </div>
      </div>

      <!-- 우측 -->
      <div class="column is-6">
        <table class="table">
          <thead>
          <tr>
            <td>이미지</td>
            <td>상품명</td>
            <td>수량</td>
            <td>상품금액</td>
            <td>삭제</td>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(order_prod,idx) in value.order_product" :key="'order_product-'+idx">
            <td><div style="text-align: center; display: inline-block;"
                     :style="imgField(order_prod.img)"></div></td>
            <td style="text-align:left !important">
              <div>{{ order_prod.name }}</div>
              <div class="flex wrap"
                   v-for="(option, option_idx) in order_prod.order_product_option"
                   :key="'option-'+option_idx">
                <span v-if="optionType(order_prod.selectorStocks, option.option_id)===0">[기본옵션]</span>
                <span v-if="optionType(order_prod.selectorStocks, option.option_id)===1">[추가옵션]</span>
                {{ optionName(order_prod.selectorStocks, option.option_id) }} X {{ option.quantity }}
              </div>
            </td>
            <td>{{ quantityValue(order_prod) }}</td>
            <td>{{ productPriceValue(order_prod) | currency }}</td>
            <!--<td>{{ calcProductPrice(order_prod) | currency }}</td>-->
            <td><button @click="deleteOrderProduct(idx)">삭제</button></td>
          </tr>
          </tbody>
        </table>
      </div>

      <div class="flex justify-center" style="padding: 8px;width:100%">
        <button class="button half" @click="$emit('closeModal')">취소</button>
        <button class="button is-primary" style="margin-left: 8px" @click="saveData">선택완료</button>
      </div>
    </div>

    <!-- 팝업 -->
    <div v-if="visible">
      <div :class="{'lp-outsider': visible===true}" @click="clickOutSide"></div>
      <div class="columns is-multiline lp-modal-wrapper"
           :class="{'lp-selectedProduct': visible===true}"
           style="height: 600px;overflow-y: auto;">
        <div class="flex wrap">
          <div class="flex-align" style="margin-bottom:20px">
            <div :style="[imgStyle]"></div>
            <div style="font-size:20px;margin-left:12px"
            >{{ selectedProduct.name }}</div>
          </div>

          <!-- 간단 설명 -->
          <div style="font-size:16px;margin-bottom:20px;width:100%" v-if="selectedProduct.simple_desc">
            {{ selectedProduct.simple_desc }}</div>

          <!-- 판매정보 -->
          <div style="width:100%">
            <!--판매가격  -->
            <div v-if="selectedProduct.product.price.discount_rate!==0"
                 style="margin-top:24px;font-size:16px;text-decoration:line-through">
              {{ selectedProduct.product.price.price | currency }}</div>
            <div class=flex-align
                 style="margin:12px 0 20px;">
              <div class=flex-align
                   style="margin:12px 0 20px;">
                <div style="font-size:24px;margin-right:8px;">{{ discountedPrice | currency }}</div>
                <div  v-if="selectedProduct.product.price.discount_rate!==0"
                      style="width:80px;font-size:16px">{{ `(${selectedProduct.product.price.discount_rate}%)` }}</div>
              </div>
            </div>

            <div style="height:1px;width:100%;margin-bottom:14px"></div>
            <div class="flex-align"
                 style="font-size:16px;width:100%">
              <div style="margin-right:3px">배송 {{ selectedProduct.product.price.delivery_price.fix_price | currency }}</div>
              <!--<div>(50,000원 이상 무료)</div>-->
            </div>
            <div style="height:1px;width:100%;margin-top:14px"></div>

            <!-- 옵션 사용 -->
            <div v-if="selectedProduct.product.enable_option">
              <div v-if="optionArr1.length>0">
                <div style="width:80px;margin-top:20px;font-size:16px">기본옵션</div>
                <span class="select">
                  <select @change="selectOption" v-if="optionArr1.length>0">
                    <option value="" disabled selected>속성 옵션 선택</option>
                    <option :value="item.value"
                            v-for="item in optionArr1" :key="item.label">{{ item.label }}</option>
                  </select>
                </span>
              </div>
              <div v-if="optionArr2.length>0">
                <div style="width:80px;margin-top:20px;font-size:16px">추가옵션</div>
                <span class="select">
                  <select @change="selectOption" v-if="optionArr2.length>0">
                    <option value="" disabled selected>추가 옵션 선택</option>
                    <option :value="item.value"
                            v-for="item in optionArr2" :key="item.label">{{ item.label }}</option>
                  </select>
                  </span>
              </div>

              <!--이름 수량 가격-->
              <div v-if="selectedProduct!==undefined"
                   v-for="(op, idx) in selectedProduct.order_product_option"
                   :key="'op-'+idx"
                   style="margin-top:20px;
                 margin-bottom: 5px;color: rgb(112, 112, 112);
                 background-color: rgb(246, 246, 246);border: 1px solid rgb(221, 221, 221);">
                <div class="flex space-between" style="padding:8px;border: 1px solid rgb(221, 221, 221);">
                  <div class="flex-align">
                    <div v-if="optionType(selectorStocks, op.option_id)===0">[기본옵션]</div>
                    <div v-if="optionType(selectorStocks, op.option_id)===1">[추가옵션]</div>
                    <div style="margin-left:4px">{{ optionName(selectorStocks, op.option_id) }}</div>
                  </div>
                  <div class="unselect">
                    <i class="material-icons"
                       style="font-size:20px"
                       @click="deleteOption(idx)"
                       v-if="op.option_id">close</i>
                  </div>
                </div>

                <div class="flex space-between" style="padding:8px">
                  <div class="flex-align">
                    <div style="margin-right:6px;">수량</div>
                    <input class="input product-short-input"
                           v-model="op.quantity"
                           @input="e=>setNumber(e, op, 3, 'option')"
                           type="number">
                  </div>
                  <div>
                    {{ optionPrice(selectorStocks, op.option_id) * op.quantity | currency }}
                  </div>
                </div>
              </div>
            </div>

            <!-- 자체 상품 수량 -->
            <div style="margin-top:20px;
                 margin-bottom: 5px;color: rgb(112, 112, 112);
                 background-color: rgb(246, 246, 246);border: 1px solid rgb(221, 221, 221);" v-else>
              <div class="flex space-between"
                   style="padding:8px;border: 1px solid rgb(221, 221, 221);"
                   v-if="selectedProduct.product.stock_type===0">
                  남은 재고수: {{ selectedProduct.product.stock }}
              </div>
              <div class="flex space-between" style="padding:8px">
                <div class="flex-align">
                  <div style="margin-right:6px;">수량</div>
                  <input class="input product-short-input"
                         v-model="selectedProduct.quantity"
                         @input="e=>setNumber(e, selectedProduct, 3, 'product')"
                         type="number">
                </div>
                <div>
                  {{ totalPrice | currency }}
                </div>
              </div>
            </div>
          </div>

          <!-- 합계 금액 -->
          <div class="flex space-between align-center" style="font-size:24px;margin-top:30px;width:100%">
            <div>총 상품 금액</div>
            <div>{{ totalPrice | currency }}</div>
          </div>
          <div class="flex justify-center" style="width:100%;margin:30px 0 30px 0">
            <button class="button is-primary" @click="addOrderProduct">상품추가하기</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import pageLengthStructure from '../../module/admin/pageLengthStructure'
  import OrderCreateMixin from "@/mixins/OrderCreateMixin"
  export default {
    components: {
      },
    mixins: [
      OrderCreateMixin
    ],
    props: {
      pack: {
        type: String,
        default: 'delivery'
      }
    },
    data() {
      return {
        tableItems: [],
        pageLengthList: pageLengthStructure.common,
        allCount: 0,
        filteredCount: 0,
        filtered: {
          cur_page: 1,
          page_num:1,
          total_page:1,
          page_length: 10
        },
        selectedProduct: undefined,
        // 상품 옵션 재고
        selectorStocks: [],
        visible:false,
        value: {
          order_product: []
        }
      }
    },
    created() {
      this.getProductList();
    },
    computed: {
      imgStyle() {
        return {
          width: '50px',
          height: '50px',
          backgroundImage: `url("${this.selectedProduct.product.img}")`,
          backgroundPosition: 'center',
          backgroundSize: 'cover',
        }
      },
      // 속성 옵션
      optionArr1() {
        let options1 = this.selectorStocks.filter(item=> {
          console.log('options1',item.option_type)
          return item.option_type===0;
        })
        return options1;
      },
      // 속성 옵션
      optionArr2() {
        let options2 = this.selectorStocks.filter(item=> {
          return item.option_type===1;
        })
        return options2;
      },
      btnStyle() {
        return {
          width: '52px',
          height: '52px',
          lineHeight: '52px',
          textAlign: 'center',
          borderRadius: '50%'
        }
      },
      lineStyle() {
        return {
          width: '0',
          height: '18px',
          border: '1px solid #dddddd',
          margin: '0 12px 0 2px'
        }
      },
      discountedPrice() {
        if (this.selectedProduct.product.price.discount_rate!==0) {
          let discountedPrice = this.selectedProduct.product.price.price * (1 - (this.selectedProduct.product.price.discount_rate / 100))
          return discountedPrice;
        }
        else return this.selectedProduct.product.price.price;
      },
      totalPrice() {
        let total = 0;
        let item = this.selectedProduct;
        // 상품 옵션
        if (item.order_product_option.length > 0) {
          item.order_product_option.forEach(option => {
            let stock = find(item.selectorStocks, 'id', option.option_id);
            if (stock && stock.option_type === 0) {
              total += stock.total_price * parseInt(option.quantity);
            }
            else total += stock.price * parseInt(option.quantity);
          })
        }
        // 자체상품
        else {
          total = item.total_price * item.quantity;
        }
        return total;
      }
    },
    methods: {
      quantityValue (op) {
        // 총 수량 (기본옵션 수량 총 합계)
        let result = 0;
        // 상품 옵션 있는 경우
        if (op.order_product_option.length > 0) {
          let opts = op.order_product_option;
          let stocks = op.selectorStocks;
          let optArr = [];
          opts.forEach(item => {
            item.option = find(stocks, 'id', item.option_id);
            optArr.push(item);
          })
          optArr.forEach(opItem => {
            // 상품속성옵션
            if (opItem.option && opItem.option.option_type === 0) {
              result += opItem.quantity;
            }
          })
        }
        // 자체 상품일 경우
        else {
          result = op.quantity;
        }
        return result;
      },
      productPriceValue (op) {
        let total = 0;
        if(op.order_product_option.length > 0) {
          op.order_product_option.forEach(option => {
            let stock = find(op.selectorStocks, 'id', option.option_id);
            if (stock && stock.option_type === 0) {
              total += stock.total_price * parseInt(option.quantity);
            }
            else total += stock.price * parseInt(option.quantity);
          })
        }
        else total = op.total_price * op.quantity;
        return total;
      },
      setNumber(e, data, max_length, type) {
        let quantity = parseInt(e.target.value.substr(0,max_length));
        console.log('수량',quantity)
        if(quantity<1) quantity = 1;
        // 옵션 사용할 경우 ( order_product_option )
        if(type==='option') {
          let selectorStocks = this.selectedProduct.selectorStocks;
          let selector_stock = find(selectorStocks, 'id', data.option_id);
          // 재고 사용할 경우 체크후 수량 반영
          if(selector_stock.enable_stock) {
            if(selector_stock.stock<quantity) data.quantity = selector_stock.stock;
            else data.quantity = quantity;
          }
          else {
            data.quantity = quantity;
          }
        }
        // 자체 상품 selectedProduct
        else {
          // 재고 사용할 경우 체크후 수량 반영
          if(data.product.stock_type===0) {
            if(data.product.stock<quantity) data.quantity = data.product.stock;
            else data.quantity = quantity;
          }
          else {
            data.quantity = quantity;
          }
        }
      },
      // 상품의 수량체크해서 추가
      addOrderProduct(){
        if(this.selectedProduct.product.enable_option) {
          if(this.selectedProduct.order_product_option.length===0) {
            this.toast('주문할 상품을 선택해주세요.');
            return;
          }

          let isOptionType0 = false;
          this.selectedProduct.order_product_option.some(op=> {
            let ss = find(this.selectorStocks, 'id', op.option_id);
            // 속성옵션 0, 추가옵션 1
            if(ss.option_type===0) isOptionType0 = true;
            return (ss.option_type===0)
          })
          if(!isOptionType0) {
            this.toast('상품 필수 옵션을 선택해주세요.');
            return;
          }
        }

        // 선택된 배송유형
        let selectedProduct = this.cloneItem(this.selectedProduct);
        selectedProduct.delivery_method = this.selectedDeliveryMethod;
        this.value.order_product.push(selectedProduct);
        // 선택 상품 닫기
        this.visible = false;
      },
      // 상품 선택
      clickProduct(prod){
        this.selectedProduct = {
          "product_id": prod.id,
          "name": prod.name,
          "quantity": 1,
          "comm_price": 0,
          "point": 0,
          "discount_price": 0,
          "total_price": 0,
          "img": prod.img,
          "delivery_price": prod.price.delivery_price,
          "order_product_option": [],
          "product": prod,
          "selectorStocks": []
        };
        this.visible = true;
        // 옵션 사용할 경우
        if(this.selectedProduct.product.enable_option) this.getSelectorStocks();
        else {
          // 자체 상품일 경우
          this.selectProduct();
        }
      },
      // 페이지 숫자 보임여부
      visiblePageNumber(n) {
        // 현재 선택된 페이지 + 9까지 보임
        if(this.filtered.page_num <= n && n <= this.filtered.page_num+9) return true;
        // 전체페이지 - 현재 페이지
        let cal_page = this.filtered.total_page - this.filtered.page_num
        if(cal_page < 5 && n >= this.filtered.total_page - 5) {
          return true
        }
        else return false;
      },
      saveData(){
        // this.initialize();
        this.$emit('addProduct', this.value.order_product);
      },
      getProductList(){
        let order_conversion_type = 3;
        if (this.pack==='mart') {
          order_conversion_type = 12;
        }
        this.$axios.get(this.getUrl(`product?order_conversion_type=${order_conversion_type}`), {
          params: this.filtered
        }).then(res=>{
          if(res.status === 200) {
            this.filtered.page_length = res.data.page_length;
            this.filtered.cur_page = res.data.cur_page;
            this.filtered.total_page = res.data.total_page;
            this.allCount = res.data.total_count;
            this.filteredCount = res.data.count;
            this.tableItems = res.data.data;
          }
        })
      },
      selPageLength(){
        this.getProductList();
      },
      changePage(num) {
        this.filtered.page_num = num;
        this.filtered.cur_page = num;
        this.getProductList();
      },
      prevPage() {
        if (this.filtered.page_num > 1) {
          this.filtered.page_num -= 1;
          this.getProductList();
        }
      },
      nextPage() {
        if (this.filtered.page_num < this.filtered.total_page) {
          this.filtered.page_num += 1;
          this.getProductList();
        }
      },
      deleteOrderProduct(index){
        // console.log('op',index)
        removeIndex(this.value.order_product, index);
      },
      deleteOption(index) {
        removeIndex(this.selectedProduct.order_product_option, index);
      },
      clickOutSide(){
        this.visible = false;
      },
      imgField(img) {
        return 'background-image: url('+this.image(img)+');' +
          ' width: 60px; height: 60px; background-size: cover;' +
          ' background-position: center;';
      },
      // 배송유형이 있을 경우 초기화 작업
      initializeDeliveryMethod() {
        let names = [
          { label: 'parcel', value: '택배' },
          { label: 'post', value: '등기 / 소포' },
          { label: 'cargo', value: '화물배송' },
          { label: 'visit', value: '방문수령' },
          { label: 'quick', value: '퀵배송' }
        ]
        // 배송 유형
        let items = this.selectedProduct.product.price.delivery_price.delivery_method;
        if(items.length>1) {
          let arr = [];
          items.forEach(item=> {
            arr.push({ label: find(names, 'label', item).value, value: item })
          })
          this.deliveryMethodArr = arr;
        }
        else {
          if(items.length===1) {
            this.deliveryMethodArr = [
              { label: find(names, 'label', items[0]).value, value: items[0] }
            ]
          }
        }
        if(items.length>0) this.selectedDeliveryMethod = items[0]
      },
      //상품 선택
      selectProduct() {
        let comm_price = 0;
        let point_price = 0;
        let discount_price = 0;
        let price = this.selectedProduct.product.price;
        let product_price = price.price;

        // 속성 옵션일 경우 상품가격 + 옵션가
        // 0: 비율, 1: 금액
        // 수수료, 포인트, 할인 계산
        if(price.is_point) {
          if(price.point_type===0) point_price = product_price * price.point_rate / 100;
          else point_price = price.point;
        }
        if(price.is_discount) {
          if(price.discount_type===0) discount_price = product_price * price.discount_rate / 100;
          else discount_price = price.discount_price;
        }
        if(price.is_comm) {
          if(price.comm_type===0) comm_price = product_price * price.comm_rate / 100;
          else comm_price = price.comm_price;
        }

        this.selectedProduct.comm_price = comm_price;
        this.selectedProduct.point = point_price;
        this.selectedProduct.discount_price = discount_price;
        this.selectedProduct.product_price = product_price;
        console.log('product_price', product_price)
        this.selectedProduct.total_price = product_price - discount_price;
      },
      // 상품옵션 선택
      selectOption(e) {
        // order_product 중복 체크 후(option id체크) 있을 경우 종료
        let value = parseInt(e.target.value);
        let op = find(this.selectedProduct.order_product_option, 'option_id', value);
        if(op) return;

        let total_price = 0;
        let comm_price = 0;
        let point_price = 0;
        let discount_price = 0;
        let price = this.selectedProduct.product.price;

        this.selectorStocks.forEach(selector=> {
          if(selector.id===value) {
            // console.log('옵션가',selector.price);
            // console.log('상품가',price.price);
            // 속성 옵션일 경우 상품가격 + 옵션가
            if(selector.option_type===0) total_price = selector.price + price.price;
            else total_price = selector.price;
            // 0: 비율, 1: 금액
            // 수수료, 포인트, 할인 계산
            if(price.point_type===0) point_price = total_price * price.point_rate / 100;
            else point_price = price.point;
            if(price.discount_type===0) discount_price = total_price * price.discount_rate / 100;
            else discount_price = price.discount_price;
            if(price.comm_type===0) comm_price = total_price * price.comm_rate / 100;
            else comm_price = price.comm_price;

            let order_product_option = {
              option_id: selector.id,
              quantity: 1
            }

            this.selectedProduct.order_product_option.push(order_product_option);
            // console.log('확인', this.order_product);
          }
        })

      },
      // 옵션 가져오기
      getSelectorStocks() {
        if(this.selectedProduct.product.id) {
          this.$axios.post(`public/product/${this.selectedProduct.product.id}/selector_stocks`)
            .then( res => {
              this.selectorStocks = res.data.stocks;
              this.selectedProduct.selectorStocks = res.data.stocks;
            });
        }
      },
      subImg(idx) {
        let deco = {
          width: '100px',
          height: '100px',
          objectFit: 'cover',
        }
        let subGutter = (Number(this.imgStyle.width.replace('px', '')) -
          Number(deco.width.replace('px', '')) * 5) / 8

        deco.marginTop = `${subGutter * 2}px`

        if(idx===0) {
          deco.marginRight = `${subGutter}px`
        }
        else if(idx===this.computedSubImg.length-1) {
          deco.marginLeft = `${subGutter}px`
        }
        else {
          deco.marginLeft = `${subGutter}px`
          deco.marginRight = `${subGutter}px`
        }
        return deco;
      },
      clickSubimg(item) {
        this.selectedImg = item;
      },
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  @import '~assets/css/lp_main'

  .pagination-group {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
  }

  .pagination-btn-prev
  .pagination-btn-next {
    display: inline-block;
    /*height: 25px;*/
  }

  .pagination-num {
    display: inline-block;
  }

  .pagination-btn-prev i
  .pagination-btn-next i {
    color: #18a4ed;
    margin: 4px;
    cursor: pointer;
  }

  .pagination-num {
    padding: 5px 8px;
    cursor: pointer;
    font-size: .9rem;
  }

  .pagination-num-selected {
    color: #18a4ed;
  }

  .pagination-num-not-selected {
    color: #666;
  }

  .product-short-input
    width 89px

  .lp-outsider
    position fixed
    left 0
    right 0
    bottom 0
    top 0
    background-color rgba(0,0,0, 0.3)
    z-index 10

  .lp-selectedProduct
    position absolute
    top 50%
    left 50%
    transform translate(-50%, -50%)
    z-index 1000
    background-color white

  .lp-option-background
    padding 8px
    background-color #eee
    border-bottom 1px solid #e0e0e0

  .lp-option-background:last-child
    border-bottom 1px solid $primary
</style>
